import dataLayerSearch from 'assets/core/js/module/searchForm/dataLayer/search'
import SelectManager from 'assets/core/js/module/selectManager'
import autocomplete from 'assets/themes/vacances-campings/js/module/searchForm/autocomplete'
import calendar from 'assets/themes/vacances-campings/js/module/searchForm/calendar'
import events from 'assets/themes/vacances-campings/js/module/searchForm/events'
import maxDistance from 'assets/themes/vacances-campings/js/module/searchForm/maxDistance'
import menus from 'assets/themes/vacances-campings/js/module/searchForm/menus'

export default function (): void {
  const calendarInstance = calendar()
  const autocompleteInstance = autocomplete()
  events()
  menus()
  maxDistance()
  const capacityInstance = SelectManager.getSelect('search_offers_capacity')

  dataLayerSearch(autocompleteInstance, calendarInstance, undefined, capacityInstance)
}
